import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { CheckboxComponent } from '@core/components/checkbox/checkbox.component';
import { DISCORD_LINK } from '@core/constants/discord.constants';
import { SessionService } from '@core/services/session.service';
import { SvgIconComponent } from 'angular-svg-icon';
@Component({
  selector: 'app-supply-drop-requirements-modal',
  imports: [CheckboxComponent, SvgIconComponent],
  templateUrl: './supply-drop-requirements-modal.component.html',
  styleUrl: './supply-drop-requirements-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class SupplyDropRequirementsModalComponent {
  public readonly sessionService = inject(SessionService);
  public readonly DISCORD_LINK = DISCORD_LINK;

  requirements = computed(() => {
    const fields = {
      level: (this.sessionService.profile()?.level ?? 0) >= 10,
      discord:
        this.sessionService.discord().linked &&
        this.sessionService.discord().joined,
    };
    return {
      ...fields,
      eligible: Object.values(fields).every((value) => value),
    };
  });
}
